/* 🤖 this file was generated by svg-to-ts */
export const IconBigBoldInfo: {
    name: 'big-bold-info';
    data: string;
} = {
    name: 'big-bold-info',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 24 24"><path d="M12 18.938a.94.94 0 0 1-.937-.938v-7.5a.938.938 0 0 1 1.874 0V18c0 .517-.42.938-.937.938M13.313 6.75a1.312 1.312 0 1 1-2.625 0 1.312 1.312 0 0 1 2.624 0"/><path fill-rule="evenodd" d="M12 23.438C5.693 23.438.563 18.308.563 12 .563 5.693 5.693.563 12 .563c6.308 0 11.438 5.13 11.438 11.437 0 6.308-5.13 11.438-11.438 11.438m0-21c-5.272 0-9.562 4.29-9.562 9.562 0 5.273 4.29 9.563 9.562 9.563 5.273 0 9.563-4.29 9.563-9.563 0-5.272-4.29-9.562-9.563-9.562" clip-rule="evenodd"/></svg>`,
};
